<template>
    <div class="admin--menu">
        <div class="admin--menu--left">
            <AdminNotifications />
            <router-link v-for="menu in menus" :key="menu"
                :to="`/admin/${menu}`"
                :class="{
                    active:isActive(`admin-${menu}`)
                }"
            >
                {{$t(`admin.${menu}`)}}
            </router-link>
            <router-link to="/admin/settings" v-if="adminUser.role == AdminUserRole.Admin"
                :class="{
                    active:isActive(`admin-settings`)
                }"
            >
                {{$t("admin.settings")}}
            </router-link>
        </div>

        <div class="admin--menu--right">
            <div v-if="adminUser" class="admin--menu--right--user">
                {{adminUser.username}}
            </div>
            <button @click="logout">
                {{$t("admin.btn_logout")}}
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue"
import AdminNotifications from "@/components/admin/AdminNotifications.vue"
import {AdminUser, AdminUserRole} from "xpark-shared/models/models"

export default defineComponent({
    components: {
        AdminNotifications
    },

    setup() {
        const json = localStorage.getItem("admin-user") || "{}"
        return {
            adminUser: JSON.parse(json) as AdminUser
        }
    },

    data() {
        return {
            menus: [
                "register",
                "teams",
                "rooms",
                "bookings",
                "export"
            ],
            AdminUserRole
        }
    },

    methods: {
        logout() {
            localStorage.removeItem("admin-user")
            this.$router.push("/admin/login")
        },

        isActive(routeName: string) {
            return this.$router.currentRoute.value?.name === routeName
        }
    }
})
</script>

<style scoped lang="scss">
.admin--menu {
    background: $color-blue;
    display: flex;
    padding: 1em;
    justify-content: space-between;
    align-items: center;
    font-size: 1.2em;

    a {
        color: white;
        display: inline-block;
        margin: 0 0.5rem;

        &.active {
            font-weight: bold;
        }
    }

    button {
        color: $color-blue;
        background: white;
        font-weight: bold;
        font-size: 1em;
        padding: 0.5rem 0.75rem;
        border: none;
    }
    &--left {
        display: flex;
        align-items: center;
    }

    &--right {
        color: white;
        display: flex;
        align-items: center;

        &--user {
            margin-right: 1rem;
        }
    }
}
</style>
